import React, {Component} from 'react';
import {MemoryRouter as Router, Route, Switch} from "react-router-dom";
import withLivesHOC from 'withLives.js';

const ComponentFirst = (props) => {
    return (
        <div>first</div>
    );
};

const ComponentSecond = (props) => {
    return (
        <div>second</div>
    );
};

class Test extends Component {

    render() {
        return (
            <div react-hybrid-component="true">
                <Router initialEntries={["/test"]} initialIndex={0}>
                    <Switch>
                        <Route path="/test" component={ComponentFirst}/>
                        <Route path="/test2" component={ComponentSecond}/>
                    </Switch>
                </Router>
            </div>
        );
    }
}

export default withLivesHOC(Test);
